import { render, staticRenderFns } from "./ShowDataText.vue?vue&type=template&id=614d6160&scoped=true"
import script from "./ShowDataText.vue?vue&type=script&lang=js"
export * from "./ShowDataText.vue?vue&type=script&lang=js"
import style0 from "./ShowDataText.vue?vue&type=style&index=0&id=614d6160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d6160",
  null
  
)

export default component.exports